module.exports = __webpack_public_path__ + "img/no-imgb.0d97ece8.jpg";